module.exports = __webpack_public_path__ + "img/patient-edit.450e51a2.svg";